var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ip-signings-view-container",attrs:{"fluid":""}},[_c('h1',[_vm._v("Zeichnungbescheinigung Sparplan")]),_vm._v(" "),_c('ip-signings-table',{attrs:{"ip-signings":_vm.ipSignings,"loading":_vm.loading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5db2c376","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ire/IpSignings.vue
// module id = null
// module chunks = 